import { AUDIENCES, AUDIENCE_ORIGINS, SECTION_HEADS } from '../../content/site';
import m from '../../styles/marketing.module.css';
import SectionHeader from './SectionHeader';
import styles from './Sections.module.css';

/** Who we serve: a hairline-ruled typographic grid beside one photo, no cards or icons. */
const Audiences = ({ tint = false }: { tint?: boolean }) => (
  <section className={`${m.section} ${tint ? m.tint : ''}`} id="who-we-serve">
    <div className={m.container}>
      <SectionHeader {...SECTION_HEADS.audiences} />
      <div className={styles.withPhoto}>
        <div className={`${m.photo} ${m.cutLeft} ${styles.sidePhoto}`} data-reveal>
          <img
            src="/images/advisory-consult.webp"
            alt="Two advisers reviewing a plan together on a tablet"
            data-parallax="0.04"
            loading="lazy"
          />
        </div>
        <div className={styles.audienceGrid}>
          {AUDIENCES.map((item, i) => (
            <article key={item.title} className={styles.audience} data-reveal data-reveal-delay={i * 80}>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </div>
      <div className={styles.origins} data-reveal>
        <span className={styles.originsLabel}>Clients from</span>
        <ul>
          {AUDIENCE_ORIGINS.map((origin) => (
            <li key={origin}>{origin}</li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default Audiences;
